import React from 'react';
import { Row, Col, Typography, Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useHandleActionPlans } from '../hooks/useHandleActionPlans';
import { ReportSelectionGrid } from './ReportSelectionGrid';
import { useDataExtractionReport } from '@/context/DataExtractionReport';
import * as S from '../styles';
import { FormItemWrapper, BodyLargeRegular } from '@/components/Settings/DataExtraction/styles';

const { Link } = Typography;
const { useWatch, useFormInstance } = Form;

export function ReportSelectionPanel() {
	const form = useFormInstance();
	const selectedReports = useWatch(['action_plans', 'selected_reports'], form) || [];
	const actionPlanReports = useHandleActionPlans();
	const { onSetSelectedReportNames } = useDataExtractionReport();

	const hasEnabledReports = actionPlanReports.some((report) => report.count > 0);
	const enabledReports = actionPlanReports.filter((report) => report.count > 0);
	const isAllSelected =
		hasEnabledReports && enabledReports.every((report) => selectedReports.includes(report.custom_report_id));

	const handleReportSelectionChange = (selectedIds: string[]) => {
		const selectedNames = selectedIds
			.map((id) => {
				const report = actionPlanReports.find((r) => r.custom_report_id === id);
				return report ? report.formatted_name : '';
			})
			.filter(Boolean);

		onSetSelectedReportNames(selectedNames);
	};

	const handleSelectAll = () => {
		const newSelection = isAllSelected ? [] : enabledReports.map((report) => report.custom_report_id);

		form.setFieldValue(['action_plans', 'selected_reports'], newSelection);
		handleReportSelectionChange(newSelection);
	};

	if (!actionPlanReports?.length) {
		return null;
	}

	return (
		<>
			<Row gutter={[0, 32]}>
				<Col span={24}>
					<Row justify="space-between" align="middle">
						<Col>
							<BodyLargeRegular>
								{I18n.get(
									'Select one or more origins for extracting action plans. If desired, you can proceed without including action plans in the extraction.'
								)}
							</BodyLargeRegular>
						</Col>
						<Col>
							<Link onClick={handleSelectAll} disabled={!hasEnabledReports}>
								{isAllSelected ? I18n.get('Deselect all') : I18n.get('Select all')}
							</Link>
						</Col>
					</Row>
				</Col>

				<Col span={24}>
					<FormItemWrapper name={['action_plans', 'selected_reports']}>
						<S.StyledCheckboxGroup
							onChange={(selectedIds) => handleReportSelectionChange(selectedIds as string[])}
						>
							<S.ToolsGrid>
								<ReportSelectionGrid reports={actionPlanReports} />
							</S.ToolsGrid>
						</S.StyledCheckboxGroup>
					</FormItemWrapper>
				</Col>
			</Row>
		</>
	);
}
